var render = function render(){var _vm=this,_c=_vm._self._c;return _c('panel',{attrs:{"header":"HD Radio properties","grid":""}},[_c('text-field',_vm._g(_vm._b({attrs:{"id":"pi_code"}},'text-field',_vm.fieldProperties('pi_code'),false),_vm.fieldHandlers))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }